import request from '@/utils/request'
import qs from 'qs'
export function getListDiscountDetail(query) {
  return request({
    url: '/report-service/v1/discount-report/discount-detail-report',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getListDiscountDetailExcel(query) {
  return request({
    url: '/report-service/v1/discount-report/discount-detail-report-excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    },
    responseType: 'blob'
  })
}

export function getListDiscountSummary(query) {
  return request({
    url: '/report-service/v1/discount-report/discount-summary-report',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getListDiscountSummaryExcel(query) {
  return request({
    url: '/report-service/v1/discount-report/discount-summary-report-excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    },
    responseType: 'blob'
  })
}
